const useTestEnvironment = (): boolean => {
	return process.env.NODE_ENV === "test";
};

export default useTestEnvironment;
